import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import { getLocale, getQuery } from '#shared/util/url.js';

import { getRequestHref } from '#backend/util/request.js';
import loadThemeLanguage from '#backend/util/loadThemeLanguage.js';

/**
 * Load request locale, make fallbacks, load region config, etc.
 */
export default defineThemeMiddleware(({ request, response, redirect }) => {
	const requestLocale = getLocale(getRequestHref(request)) || 'en-ww';
	const providerNameFromSession = response.locals.sessionStore?.store.cartParameters.providerName;
	const providerNameFromRequest = getQuery(getRequestHref(request), 'provider');
	const requestProvider = providerNameFromSession || providerNameFromRequest;
	const { locale, language, region, regionConfig } = loadThemeLanguage(requestLocale, requestProvider, response.locals.theme.config.locales);
	// If requested locale format is valid, but not configured for the theme, redirect to the fallback locale
	if (/[a-z]{2}-[a-z]{2}/.test(requestLocale) && requestLocale !== locale) {
		redirect(301, getRequestHref(request).replace(requestLocale, locale));
		return;
	}
	// Store valid values into response context for future reference
	response.locals.locale = locale;
	response.locals.language = language;
	response.locals.region = region;
	response.locals.regionConfig = regionConfig;
}, (context) => context.isServerProcess);
